import React from 'react';
import AboutUs from '../component/aboutUs/AboutUs';
import { Helmet } from 'react-helmet';
import ComponenetHeader from '../component/common/ComponenetHeader';

const AboutPage = () => {

  return (
    <>
      <Helmet>
        <link rel="canonical" href="/about"/>
        <title>Truck Maintenance & Roadside Assistance | Online Road Services</title>
        <meta name="keywords" content="tow truck services, truck trailer repair, heavy duty truck repair, commercial truck repair, truck maintenance"/>
        <meta name="description" content="Explore truck maintenance and 24/7 roadside assistance with Online Road Services. Our certified technicians ensure your fleet stays road-ready and compliant" />

        <meta property="og:title" content="Truck Maintenance & Roadside Assistance | Online Road Services" />
        <meta property="og:description" content="Explore truck maintenance and 24/7 roadside assistance with Online Road Services. Our certified technicians ensure your fleet stays road-ready and compliant" />
      </Helmet>
      <ComponenetHeader
        name={'About Us'}
      />
      <AboutUs />
    </>
  );
};

export default AboutPage;